import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { CoreService } from 'app/services/entidades/core.service';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class UsersService extends CoreService {

  constructor(
    private _http: Http
  ) {
    super(_http);
  }

  /**
   * Regresa los usuarios del sistema
   * @return {any} Objeto json con los datos de los usuarios
   */
  get(idusuario: number = null): Observable<any> {
    if (idusuario) {
      return this.getMethod(`user/${idusuario}`);
    } else {
      return this.getMethod('user/');
    }
  }

  /**
   * Crea un nuevo usuario en el sistema
   * @param  {object} user Datos del usuario
   * @return {any}      Respuesta del servidor
   */
  add(user: any): Observable<any> {
    return this.postMethod('user/', user);
  }

  /**
   * Servicio para editar un usuario
   * @param  {any} usuario Datos del usuario
   * @return {any}         Objeto json con los resultados del insert
   */
  edit(usuario: any): Observable<any> {
    return this.putMethod('user/', usuario);
  }

  editPass(usuario: any): Observable<any> {
    return this.putMethod('user/userchangepassword', usuario);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/entidades/users.service.ts